import Axios from 'axios';
import Cookies from 'js-cookie';
import {
  API_ROOT
} from '../config';

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000

});
console.log(API_ROOT);

export default {
  state: {
    access: false,
    user: {
      "id": 0,
      "role_id": 0,
      "gender_id": 0,
      "birthplace_id": 0,
      "denomination_id": 0,
      "nativeLanguage_id": 0,
      "nationality_id": 0,
      "surname": "",
      "preposition": "",
      "firstname": "",
      "nickname": "",
      "birthdate": "",
      "governement_id": "",
      "address": "",
      "neighborhood": "",
      "telephone": "",
      "email": ""
    }
  },
  mutations: {
    LOGIN(state, login_obj) {
      console.log('Login');
      console.log(login_obj.data);
      Cookies.remove('user');
      Cookies.remove('access');
      state.access = 0;
      state.user = null;
      console.log(JSON.stringify(login_obj.data));
      Cookies.set('user', JSON.stringify(login_obj.data));
      Cookies.set('access', login_obj.success);
      state.access = Cookies.get('access');
      state.user = Cookies.getJSON('user');
      state.login_obj = login_obj;
    },
    LOGOUT(state) {
      console.log('Logout');
      Cookies.remove('user');
      Cookies.remove('access');
      state.access = 0;
      state.user = null;
    }
  },
  getters: {
    getLoggedin(state) {
      return state.access;
    },
    getUser(state) {
      return state.user;
    }
  },
  actions: {
    logout(context) {
      context.commit('LOGOUT');
    },
    login(context, obj) {
      console.log(context);
      var self = this;
      instance.post('/login', {
          username: obj.username,
          password: obj.password
        }).then(function (response) {
          console.log(response);
          var obj = response.data;

          context.commit('LOGIN', obj);

        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
